export const getDefaultRouteForRole = (role) => {
  const numericRole = Number(role);

  if (numericRole === 1 || numericRole === 2) {
    return "/admin/dashboard";
  }

  return "/home";
};
